// extracted by mini-css-extract-plugin
export default {"btn":"IconButton_btn__QLiJj","dot":"IconButton_dot__Velfu"};